import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import ReportIcon from '@mui/icons-material/Report';
import sty from './alert.module.css';
import { useActivePatrolUI } from '../../context/activePatrol/ActivePatrolUIProvider';
import { useActivePatrolLogic } from '../../context/activePatrol/ActivePatrolLogicProvider';

function PatrolUnsavedWarning() {
	const { showUnsavedWarningModal, setShowUnsavedWarningModal } =
		useActivePatrolUI();
	const { finalizeExitPatrol, savePatrol } = useActivePatrolLogic();

	const handleCloseModal = () => {
		setShowUnsavedWarningModal(false);
	};

	const handleLeaveWithoutSaving = () => {
		setShowUnsavedWarningModal(false);
		finalizeExitPatrol();
	};

	const handleLeaveAfterSave = () => {
		setShowUnsavedWarningModal(false);
		savePatrol(finalizeExitPatrol);
	};

	return (
		<Dialog
			open={showUnsavedWarningModal}
			onClose={handleCloseModal}
			aria-labelledby="draggable-dialog-title"
		>
			<div className={sty.header_bar} />
			<section className={sty.dialog_section}>
				<ReportIcon className={sty.icon} />
				<div className={sty.dialog_title_content}>
					<DialogTitle
						className={sty.dialog_title}
						id="draggable-dialog-title"
					>
						Unsaved changes
					</DialogTitle>
					<DialogContent className={sty.dialog_content}>
						<DialogContentText>
							You are about to leave this content without saving.
							All changes will be lost. Do you want to leave
							without saving?
						</DialogContentText>
					</DialogContent>
				</div>
			</section>
			<Divider />
			<DialogActions className={sty.dialog_actions}>
				<Button
					variant="outlined"
					size="medium"
					onClick={handleCloseModal}
					className={sty.action_button}
				>
					Back
				</Button>
				<Button
					variant="contained"
					size="medium"
					onClick={handleLeaveWithoutSaving}
					className={sty.action_button}
					color="error"
				>
					Leave without saving
				</Button>
				<Button
					variant="contained"
					size="medium"
					onClick={handleLeaveAfterSave}
					className={sty.action_button}
				>
					Save Changes
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default PatrolUnsavedWarning;
